import React from 'react';
import AdminTopNav from './AdminTopNav';
import AdminSideNav from './AdminSideNav';

export default function AdminLayout({ children, title, subtitle, onYearChange, onExportPDF }) {
  return (
    <>
      <AdminSideNav />
      <div className="dashboard-main-content">
        <AdminTopNav title={title} subtitle={subtitle} onYearChange={onYearChange} onExportPDF={onExportPDF} />
        <div className="dashboard-content">{children}</div>
      </div>
    </>
  );
}